import React, { useState } from "react";
import { Link } from "react-router-dom";
import SEO from "components/SEO/SEO";
import { Modal } from "react-bootstrap";
import Slider from "react-slick";
import "./About.css";
import bng1 from "assets/gallery/bng1.jpg";
import bng2 from "assets/gallery/bng2.jpg";
import bng3 from "assets/gallery/bng3.jpg";
import bng4 from "assets/gallery/bng4.jpg";
import off1 from "assets/gallery/off1.jpg";
import off2 from "assets/gallery/off2.jpg";
import off3 from "assets/gallery/off3.jpg";
import off4 from "assets/gallery/off4.jpg";
import off5 from "assets/gallery/off5.jpg";
import off6 from "assets/gallery/off6.jpg";
import off7 from "assets/gallery/off7.jpg";
import off8 from "assets/gallery/off8.jpg";
import off9 from "assets/gallery/off9.jpg";
import off10 from "assets/gallery/off10.jpg";
import badDebtCard from "assets/about/impacts-of-debt.png";
import guidelines from "assets/about/guidelines.png";

const GALLERY = [
  { src: bng1, alt: "CSR Associates Bangalore office exterior" },
  { src: bng2, alt: "CSR Associates team Bangalore" },
  { src: bng3, alt: "CSR Associates Bangalore branch" },
  { src: bng4, alt: "CSR Associates Bangalore operations" },
  { src: off1, alt: "CSR Associates office operations" },
  { src: off2, alt: "CSR Associates debt recovery team" },
  { src: off3, alt: "CSR Associates BPO operations" },
  { src: off4, alt: "CSR Associates field team" },
  { src: off5, alt: "CSR Associates call center operations" },
  { src: off6, alt: "CSR Associates collections team" },
  { src: off7, alt: "CSR Associates office Bangalore" },
  { src: off8, alt: "CSR Associates professionals" },
  { src: off9, alt: "CSR Associates team meeting" },
  { src: off10, alt: "CSR Associates management team" },
];

export default function About() {
  const [showModal, setShowModal] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);

  const handleImageClick = (index) => {
    setCurrentSlide(index);
    setShowModal(true);
  };

  return (
    <>
      <SEO
        title="About CSR Associates | Debt Recovery Company Bangalore Since 2012"
        description="Learn about CSR Associates — Bangalore's leading debt recovery and BPO company. Founded 2012. Trusted by 500+ banks and NBFCs. Ethical, RBI-compliant collections across Karnataka."
        keywords="about CSR Associates, debt recovery company bangalore, BPO company karnataka, collections agency history"
      />
      <div className="about-page">
        <div className="container" style={{ maxWidth: 1200, margin: "0 auto", padding: "80px 24px" }}>

          {/* Hero */}
          <div className="page-hero" data-aos="fade-up">
            <span className="page-hero-tag">About Us</span>
            <h1 className="page-hero-title">
              Built on <em>Trust</em>,<br />Driven by Results
            </h1>
            <p className="page-hero-sub">
              12+ years of ethical debt recovery and outsourcing excellence from Bangalore to the world.
            </p>
            <div className="page-hero-divider" />
          </div>

          {/* What We Do */}
          <div className="info-card" data-aos="fade-up">
            <h2>What We Do</h2>
            <p>
              At CSR Associates, we specialise in banking process outsourcing, focusing on ethical and
              effective debt collection for MNC banks, NBFCs, and fintechs. Our dedicated team uses
              technology and industry insight to manage complex financial operations, improve customer
              experience, and ensure compliance. We provide a comprehensive suite of services including
              early-stage delinquency management, legal recovery support, customer relationship management,
              field collections, skip tracing, and BPO services — all delivered with full RBI Fair
              Practices Code compliance.
            </p>
          </div>

          {/* Contribution */}
          <div className="info-card" data-aos="fade-up" data-aos-delay="100">
            <h2>Contribution to India's Financial Ecosystem</h2>
            <p>
              We serve as a crucial extension of the financial sector's recovery infrastructure,
              specialising in efficient and ethical debt resolution. Our targeted interventions
              significantly boost asset realisation rates, translating directly into healthier
              balance sheets for our banking and NBFC partners. By professionalising the recovery
              process with RBI-compliant operations, we safeguard client reputations and allow
              financial institutions to focus on their core mandate of serving India's growing economy.
            </p>
          </div>

          {/* Backstory */}
          <div className="info-card" data-aos="fade-up" data-aos-delay="150">
            <h2>Our Story — Founded 2012, Bangalore</h2>
            <p>
              Founded in 2012 with a vision to revolutionise financial recovery, CSR Associates
              has grown from a 2-person team to Karnataka's most trusted collections and outsourcing
              firm. Our founder's passion for ethical practices set the tone for over a decade of
              innovation, resilience, and trust-building. We've navigated market fluctuations and
              regulatory changes, emerging stronger by continuously adapting to the evolving needs
              of India's financial sector. Our journey reflects an unwavering commitment to compliance,
              transparency, and a human-centric approach that has earned us the trust of leading
              financial institutions across India.
            </p>
          </div>

          {/* Blog Cards */}
          <div style={{ marginBottom: "48px" }} data-aos="fade-up">
            <div className="eyebrow">Latest Insights</div>
            <h2 className="section-heading" style={{ marginBottom: "28px" }}>
              From Our <span className="accent">Knowledge Hub</span>
            </h2>
            <div className="blog-grid">
              <div className="blog-card">
                <img src={badDebtCard} alt="Impacts of bad debt on businesses India" loading="lazy" />
                <div className="blog-card-body">
                  <h4>The Real Cost of Bad Debt — What Every Business Must Know</h4>
                  <p>Understand how unrecovered debt impacts balance sheets, credit ratings, and long-term financial health.</p>
                  <Link to="/impacts-of-bad-debt" className="blog-link">Read Article →</Link>
                </div>
              </div>
              <div className="blog-card">
                <img src={guidelines} alt="RBI guidelines debt recovery India" loading="lazy" />
                <div className="blog-card-body">
                  <h4>RBI Guidelines for Default Loan Recovery — Complete Guide</h4>
                  <p>A comprehensive overview of the Reserve Bank of India's Fair Practices Code for ethical debt collection.</p>
                  <Link to="/guidelines-for-default-loan-recovery" className="blog-link">Read Article →</Link>
                </div>
              </div>
            </div>
          </div>

          {/* Gallery */}
          <div data-aos="fade-up">
            <div className="eyebrow">Gallery</div>
            <h2 className="section-heading" style={{ marginBottom: "28px" }}>
              Our <span className="accent">Operations</span>
            </h2>
            <div className="gallery-grid">
              {GALLERY.map((img, i) => (
                <img
                  key={i}
                  src={img.src}
                  alt={img.alt}
                  className="gallery-thumb"
                  loading="lazy"
                  onClick={() => handleImageClick(i)}
                />
              ))}
            </div>
          </div>
        </div>

        {/* Lightbox Modal */}
        <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
          <Modal.Header closeButton>
            <Modal.Title style={{ fontFamily: "var(--serif)", color: "var(--gold)", fontWeight: 300 }}>
              CSR Associates Gallery
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ padding: "8px 40px 24px" }}>
            <Slider initialSlide={currentSlide} dots infinite speed={500} slidesToShow={1} slidesToScroll={1}>
              {GALLERY.map((img, i) => (
                <div key={i}>
                  <img src={img.src} alt={img.alt} style={{ width: "100%", borderRadius: 8, maxHeight: 500, objectFit: "contain" }} />
                </div>
              ))}
            </Slider>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
}
